/** Prototype-aligned badges (misc-admin-panel.css). */
export const templateBadgeSx = {
    active: {
        height: 24,
        fontSize: 12,
        fontWeight: 500,
        bgcolor: '#d1fae5',
        color: '#047857',
        border: 'none',
    },
    inactive: {
        height: 24,
        fontSize: 12,
        fontWeight: 500,
        bgcolor: '#f3f4f6',
        color: '#64748b',
        border: 'none',
    },
    restricted: {
        height: 24,
        fontSize: 12,
        fontWeight: 500,
        bgcolor: '#fef3c7',
        color: '#b45309',
        border: 'none',
        mr: 0.75,
    },
    errorCode: {
        height: 24,
        fontSize: 12,
        fontWeight: 500,
        bgcolor: '#dbeafe',
        color: '#1d4ed8',
        border: 'none',
        mr: 0.75,
    },
};

export const templateCardSx = {
    root: {
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        mb: 1.125,
        overflow: 'hidden',
        bgcolor: '#fff',
        boxShadow: 'none',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        gap: 1.125,
        px: '15px',
        py: '12px',
        cursor: 'pointer',
        transition: 'background 0.1s',
        bgcolor: '#fff',
        '&:hover': { bgcolor: '#f9fafb' },
    },
    headerExpanded: {
        bgcolor: '#f9fafb',
    },
    name: {
        fontSize: 16,
        fontWeight: 500,
        flex: 1,
        color: '#0f172a',
    },
    meta: {
        fontSize: 14,
        color: '#64748b',
        mr: 1,
        whiteSpace: 'nowrap',
    },
    body: {
        px: '16px',
        py: '14px',
        borderTop: '1px solid #e2e8f0',
        bgcolor: '#f9fafb',
    },
    subject: {
        fontSize: 15,
        color: '#64748b',
        mb: 1.125,
        '& strong': { color: '#0f172a', fontWeight: 500 },
    },
    preview: {
        p: '11px 13px',
        mb: 1.375,
        borderRadius: '8px',
        bgcolor: '#fff',
        border: '1px solid #e2e8f0',
        fontSize: 15,
        lineHeight: 1.7,
        maxHeight: 150,
        overflow: 'auto',
    },
};
